import React from "react";
import cn from "classnames";
import styles from "./Theme.module.sass";
import useDarkMode from "use-dark-mode";
import Icon from "../Icon";

const Theme = ({ className }) => {
  const darkMode = useDarkMode(false);

  return (
    <button
      className={cn(className, styles.theme)}
      onClick={darkMode.toggle}
      type="button"
    >
      <Icon name={darkMode.value ? "sun" : "moon"} size="20" />
    </button>
  );
};

export default Theme;
